import { render, staticRenderFns } from "./UpgradeInfos.vue?vue&type=template&id=c7b8dee8&"
import script from "./UpgradeInfos.vue?vue&type=script&lang=js&"
export * from "./UpgradeInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports